export default __webpack_public_path__ + "static/media/Imgpsh.38ec811d.jpg";